module.exports = __webpack_public_path__ + "img/wildcard-used.0e459a13.svg";